import styled from "styled-components";

export const ToastContainer = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgb(196 225 255 / 90%);
    color: #3a5a7c;
    padding: 14px 0;
    font-size: 14px;
    font-family: S-Core-Dream;
    font-weight: 600;
    text-align: center;
    z-index: 999;
    border-radius: 25px 25px 0 0;
    transform: translateY(100%);
    transition: transform 0.6s ease;
    &.show {
        transform: translateY(0);
    }
`;
